Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setGestureState = exports.scrollTo = exports.measure = exports.dispatchCommand = void 0;
var _PlatformChecker = require("./PlatformChecker");
var IS_NATIVE = !(0, _PlatformChecker.shouldBeUseWeb)();
var measure;
var _worklet_12299938811179_init_data = {
    code: 'function anonymous(animatedRef){if(!_WORKLET){return null;}const viewTag=animatedRef();if(viewTag===-1){console.warn("[Reanimated] The view with tag "+viewTag+" is not a valid argument for measure(). This may be because the view is not currently rendered, which may not be a bug (e.g. an off-screen FlatList item).");return null;}const measured=global._IS_FABRIC?_measureFabric(viewTag):_measurePaper(viewTag);if(measured===null){console.warn("[Reanimated] The view with tag "+viewTag+" has some undefined, not-yet-computed or meaningless value of `LayoutMetrics` type. This may be because the view is not currently rendered, which may not be a bug (e.g. an off-screen FlatList item).");return null;}else if(measured.x===-1234567){console.warn("[Reanimated] The view with tag "+viewTag+" returned an invalid measurement response.");return null;}else if(isNaN(measured.x)){console.warn("[Reanimated] The view with tag "+viewTag+" gets view-flattened on Android. To disable view-flattening, set `collapsable={false}` on this component.");return null;}else{return measured;}}',
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts",
    sourceMap: '{"version":3,"names":["anonymous","animatedRef","_WORKLET","viewTag","console","warn","measured","global","_IS_FABRIC","_measureFabric","_measurePaper","x","isNaN"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts"],"mappings":"AAkDa,SAAAA,UAAAC,WAAgB,EAEzB,GAAI,CAACC,QAAQ,CAAE,CACb,MAAO,KAAI,CACb,CAEA,KAAM,CAAAC,OAAO,CAAIF,WAAW,CAAS,CAAC,CACtC,GAAIE,OAAO,GAAK,CAAC,CAAC,CAAE,CAClBC,OAAO,CAACC,IAAI,mCACwBF,OAAQ,6JAC5C,CAAC,CACD,MAAO,KAAI,CACb,CAEA,KAAM,CAAAG,QAAQ,CAAGC,MAAM,CAACC,UAAU,CAE9BC,cAAc,CAAEN,OAA4B,CAAC,CAE7CO,aAAa,CAAEP,OAAiB,CAAC,CACrC,GAAIG,QAAQ,GAAK,IAAI,CAAE,CACrBF,OAAO,CAACC,IAAI,mCACwBF,OAAQ,yMAC5C,CAAC,CACD,MAAO,KAAI,CACb,CAAC,IAAM,IAAIG,QAAQ,CAACK,CAAC,GAAK,CAAC,OAAO,CAAE,CAClCP,OAAO,CAACC,IAAI,mCACwBF,OAAQ,6CAC5C,CAAC,CACD,MAAO,KAAI,CACb,CAAC,IAAM,IAAIS,KAAK,CAACN,QAAQ,CAACK,CAAC,CAAC,CAAE,CAC5BP,OAAO,CAACC,IAAI,mCACwBF,OAAQ,4GAC5C,CAAC,CACD,MAAO,KAAI,CACb,CAAC,IAAM,CACL,MAAO,CAAAG,QAAQ,CACjB,CACF"}',
    version: "3.5.4"
};
if ((0, _PlatformChecker.isWeb)()) {
    exports.measure = measure = function measure(animatedRef) {
        var element = animatedRef();
        if (element === -1) {
            console.warn("[Reanimated] The view with tag ".concat(element, " is not a valid argument for measure(). This may be because the view is not currently rendered, which may not be a bug (e.g. an off-screen FlatList item)."));
            return null;
        }
        var viewportOffset = element.getBoundingClientRect();
        return {
            width: element.offsetWidth,
            height: element.offsetHeight,
            x: element.offsetLeft,
            y: element.offsetTop,
            pageX: viewportOffset.left,
            pageY: viewportOffset.top
        };
    };
} else if ((0, _PlatformChecker.isChromeDebugger)()) {
    exports.measure = measure = function measure() {
        console.warn("[Reanimated] measure() cannot be used with Chrome Debugger.");
        return null;
    };
} else if ((0, _PlatformChecker.isJest)()) {
    exports.measure = measure = function measure() {
        console.warn("[Reanimated] measure() cannot be used with Jest.");
        return null;
    };
} else if (IS_NATIVE) {
    exports.measure = measure = function() {
        var _e = [
            new global.Error(),
            1,
            -27
        ];
        var anonymous = function anonymous(animatedRef) {
            if (!_WORKLET) {
                return null;
            }
            var viewTag = animatedRef();
            if (viewTag === -1) {
                console.warn("[Reanimated] The view with tag ".concat(viewTag, " is not a valid argument for measure(). This may be because the view is not currently rendered, which may not be a bug (e.g. an off-screen FlatList item)."));
                return null;
            }
            var measured = global._IS_FABRIC ? _measureFabric(viewTag) : _measurePaper(viewTag);
            if (measured === null) {
                console.warn("[Reanimated] The view with tag ".concat(viewTag, " has some undefined, not-yet-computed or meaningless value of `LayoutMetrics` type. This may be because the view is not currently rendered, which may not be a bug (e.g. an off-screen FlatList item)."));
                return null;
            } else if (measured.x === -1234567) {
                console.warn("[Reanimated] The view with tag ".concat(viewTag, " returned an invalid measurement response."));
                return null;
            } else if (isNaN(measured.x)) {
                console.warn("[Reanimated] The view with tag ".concat(viewTag, " gets view-flattened on Android. To disable view-flattening, set `collapsable={false}` on this component."));
                return null;
            } else {
                return measured;
            }
        };
        anonymous.__closure = {};
        anonymous.__initData = _worklet_12299938811179_init_data;
        anonymous.__workletHash = 12299938811179;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else {
    exports.measure = measure = function measure() {
        console.warn("[Reanimated] measure() is not supported on this configuration.");
        return null;
    };
}
var dispatchCommand;
var _worklet_10673738910044_init_data = {
    code: "function anonymous(animatedRef,commandName,args=[]){if(!_WORKLET){return;}const shadowNodeWrapper=animatedRef();_dispatchCommandFabric(shadowNodeWrapper,commandName,args);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts",
    sourceMap: '{"version":3,"names":["anonymous","animatedRef","commandName","args","_WORKLET","shadowNodeWrapper","_dispatchCommandFabric"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts"],"mappings":"AAwGoB,QAAC,CAAAA,UAAAC,WAAa,CAAAC,WAAiB,CAAGC,IAAO,KAEzD,GAAI,CAACC,QAAQ,CAAE,CACb,OACF,CAEA,KAAM,CAAAC,iBAAiB,CAAGJ,WAAW,CAAC,CAAsB,CAE5DK,sBAAsB,CAAED,iBAAiB,CAAEH,WAAW,CAAEC,IAAI,CAAC,CAC/D"}',
    version: "3.5.4"
};
var _worklet_10978585963255_init_data = {
    code: "function anonymous(animatedRef,commandName,args=[]){if(!_WORKLET){return;}const viewTag=animatedRef();_dispatchCommandPaper(viewTag,commandName,args);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts",
    sourceMap: '{"version":3,"names":["anonymous","animatedRef","commandName","args","_WORKLET","viewTag","_dispatchCommandPaper"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts"],"mappings":"AAmHoB,QAAC,CAAAA,UAAAC,WAAa,CAAAC,WAAiB,CAAGC,IAAO,KAEzD,GAAI,CAACC,QAAQ,CAAE,CACb,OACF,CAEA,KAAM,CAAAC,OAAO,CAAGJ,WAAW,CAAC,CAAW,CAEvCK,qBAAqB,CAAED,OAAO,CAAEH,WAAW,CAAEC,IAAI,CAAC,CACpD"}',
    version: "3.5.4"
};
if (IS_NATIVE && global._IS_FABRIC) {
    exports.dispatchCommand = dispatchCommand = function() {
        var _e = [
            new global.Error(),
            1,
            -27
        ];
        var anonymous = function anonymous(animatedRef, commandName) {
            var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            if (!_WORKLET) {
                return;
            }
            var shadowNodeWrapper = animatedRef();
            _dispatchCommandFabric(shadowNodeWrapper, commandName, args);
        };
        anonymous.__closure = {};
        anonymous.__initData = _worklet_10673738910044_init_data;
        anonymous.__workletHash = 10673738910044;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else if (IS_NATIVE) {
    exports.dispatchCommand = dispatchCommand = function() {
        var _e = [
            new global.Error(),
            1,
            -27
        ];
        var anonymous = function anonymous(animatedRef, commandName) {
            var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            if (!_WORKLET) {
                return;
            }
            var viewTag = animatedRef();
            _dispatchCommandPaper(viewTag, commandName, args);
        };
        anonymous.__closure = {};
        anonymous.__initData = _worklet_10978585963255_init_data;
        anonymous.__workletHash = 10978585963255;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else if ((0, _PlatformChecker.isWeb)()) {
    exports.dispatchCommand = dispatchCommand = function dispatchCommand() {
        console.warn("[Reanimated] dispatchCommand() is not supported on web.");
    };
} else if ((0, _PlatformChecker.isChromeDebugger)()) {
    exports.dispatchCommand = dispatchCommand = function dispatchCommand() {
        console.warn("[Reanimated] dispatchCommand() is not supported with Chrome Debugger.");
    };
} else if ((0, _PlatformChecker.isJest)()) {
    exports.dispatchCommand = dispatchCommand = function dispatchCommand() {
        console.warn("[Reanimated] dispatchCommand() is not supported with Jest.");
    };
} else {
    exports.dispatchCommand = dispatchCommand = function dispatchCommand() {
        console.warn("[Reanimated] dispatchCommand() is not supported on this configuration.");
    };
}
var scrollTo;
var _worklet_10594914629867_init_data = {
    code: "function anonymous(animatedRef,x,y,animated){const{dispatchCommand}=this.__closure;dispatchCommand(animatedRef,'scrollTo',[x,y,animated]);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts",
    sourceMap: '{"version":3,"names":["anonymous","animatedRef","x","y","animated","dispatchCommand","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts"],"mappings":"AAqKa,QAAC,CAAAA,UAAAC,WAAmB,CAAAC,CAAA,CAAAC,CAAA,CAAQC,QAAK,QAAAC,eAAA,OAAAC,SAAA,CAE1CD,eAAe,CAACJ,WAAW,CAAS,UAAU,CAAE,CAACC,CAAC,CAAEC,CAAC,CAAEC,QAAQ,CAAC,CAAC,CACnE"}',
    version: "3.5.4"
};
var _worklet_17535200995213_init_data = {
    code: "function anonymous(animatedRef,x,y,animated){if(!_WORKLET){return;}const viewTag=animatedRef();_scrollToPaper(viewTag,x,y,animated);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts",
    sourceMap: '{"version":3,"names":["anonymous","animatedRef","x","y","animated","_WORKLET","viewTag","_scrollToPaper"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts"],"mappings":"AA0Ka,QAAC,CAAAA,UAAAC,WAAmB,CAAAC,CAAA,CAAAC,CAAA,CAAQC,QAAK,EAE1C,GAAI,CAACC,QAAQ,CAAE,CACb,OACF,CAGA,KAAM,CAAAC,OAAO,CAAIL,WAAW,CAAS,CAAW,CAEhDM,cAAc,CAAED,OAAO,CAAEJ,CAAC,CAAEC,CAAC,CAAEC,QAAQ,CAAC,CAC1C"}',
    version: "3.5.4"
};
if ((0, _PlatformChecker.isWeb)()) {
    exports.scrollTo = scrollTo = function scrollTo(animatedRef, x, y, animated) {
        var element = animatedRef();
        if (element !== -1) {
            element == null ? void 0 : element.scrollTo({
                x: x,
                y: y,
                animated: animated
            });
        }
    };
} else if (IS_NATIVE && global._IS_FABRIC) {
    exports.scrollTo = scrollTo = function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var anonymous = function anonymous(animatedRef, x, y, animated) {
            dispatchCommand(animatedRef, "scrollTo", [
                x,
                y,
                animated
            ]);
        };
        anonymous.__closure = {
            dispatchCommand: dispatchCommand
        };
        anonymous.__initData = _worklet_10594914629867_init_data;
        anonymous.__workletHash = 10594914629867;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else if (IS_NATIVE) {
    exports.scrollTo = scrollTo = function() {
        var _e = [
            new global.Error(),
            1,
            -27
        ];
        var anonymous = function anonymous(animatedRef, x, y, animated) {
            if (!_WORKLET) {
                return;
            }
            var viewTag = animatedRef();
            _scrollToPaper(viewTag, x, y, animated);
        };
        anonymous.__closure = {};
        anonymous.__initData = _worklet_17535200995213_init_data;
        anonymous.__workletHash = 17535200995213;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else if ((0, _PlatformChecker.isChromeDebugger)()) {
    exports.scrollTo = scrollTo = function scrollTo() {
        console.warn("[Reanimated] scrollTo() is not supported with Chrome Debugger.");
    };
} else if ((0, _PlatformChecker.isJest)()) {
    exports.scrollTo = scrollTo = function scrollTo() {
        console.warn("[Reanimated] scrollTo() is not supported with Jest.");
    };
} else {
    exports.scrollTo = scrollTo = function scrollTo() {
        console.warn("[Reanimated] scrollTo() is not supported on this configuration.");
    };
}
var setGestureState;
var _worklet_10929280418852_init_data = {
    code: "function anonymous(handlerTag,newState){if(!_WORKLET){console.warn('[Reanimated] You can not use setGestureState in non-worklet function.');return;}_setGestureState(handlerTag,newState);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts",
    sourceMap: '{"version":3,"names":["anonymous","handlerTag","newState","_WORKLET","console","warn","_setGestureState"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/NativeMethods.ts"],"mappings":"AA0MoB,QAAC,CAAAA,UAAAC,UAAY,CAAQC,QAAK,EAE1C,GAAI,CAACC,QAAQ,CAAE,CACbC,OAAO,CAACC,IAAI,CACV,uEACF,CAAC,CACD,OACF,CACAC,gBAAgB,CAACL,UAAU,CAAEC,QAAQ,CAAC,CACxC"}',
    version: "3.5.4"
};
if (IS_NATIVE) {
    exports.setGestureState = setGestureState = function() {
        var _e = [
            new global.Error(),
            1,
            -27
        ];
        var anonymous = function anonymous(handlerTag, newState) {
            if (!_WORKLET) {
                console.warn("[Reanimated] You can not use setGestureState in non-worklet function.");
                return;
            }
            _setGestureState(handlerTag, newState);
        };
        anonymous.__closure = {};
        anonymous.__initData = _worklet_10929280418852_init_data;
        anonymous.__workletHash = 10929280418852;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else if ((0, _PlatformChecker.isWeb)()) {
    exports.setGestureState = setGestureState = function setGestureState() {
        console.warn("[Reanimated] setGestureState() is not available on web.");
    };
} else if ((0, _PlatformChecker.isChromeDebugger)()) {
    exports.setGestureState = setGestureState = function setGestureState() {
        console.warn("[Reanimated] setGestureState() cannot be used with Chrome Debugger.");
    };
} else if ((0, _PlatformChecker.isJest)()) {
    exports.setGestureState = setGestureState = function setGestureState() {
        console.warn("[Reanimated] setGestureState() cannot be used with Jest.");
    };
} else {
    exports.setGestureState = setGestureState = function setGestureState() {
        console.warn("[Reanimated] setGestureState() is not supported on this configuration.");
    };
}
